import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { BreadcrumbRenderer } from '@atlassian/jira-breadcrumbs/src';

const wrapperStyles = xcss({
	/* negates margin added by original component */
	marginLeft: 'space.negative.050',
});

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<Box xcss={wrapperStyles}>
		<BreadcrumbRenderer />
	</Box>
);
